const defaultLensTechnologies = [
  {
    tech: '4ko',
    icon: 'sgi sgi-21-4ko',
    choicePrefix: 'N',
    description: 'Built from industry-standard materials, high performance in all conditions.'
  },
  {
    tech: '4kop',
    icon: 'sgi sgi-21-4ko',
    choicePrefix: 'P',
    badge: 'Polarised',
    description: '4KO<sup>®</sup> plus anti-glare and contrast-enhancing polarisation.'
  },
  {
    tech: '8ko',
    icon: 'sgi sgi-21-8ko',
    choicePrefix: '8',
    badge: 'Bestseller',
    badgeColor: 'blue',
    description: 'SEE BETTER. Industry-leading materials for unrivalled performance.'
  },
  {
    tech: '8kop',
    icon: 'sgi sgi-21-8ko',
    choicePrefix: '8P',
    badge: 'Polarised',
    description: 'Our BEST lens yet. 8KO<sup>®</sup> plus anti-glare and contrast-enhancing polarisation.'
  }
]

const experimentLensTechnologies = [
  {
    tech: '4ko',
    icon: 'sgi sgi-21-4ko',
    choicePrefix: 'N',
    description: 'Built from industry-standard materials, high performance in all conditions.'
  },
  {
    tech: '4kop',
    icon: 'sgi sgi-21-4kop',
    choicePrefix: 'P',
    description: '4KO<sup>®</sup> plus anti-glare and contrast-enhancing polarisation.'
  },
  {
    tech: '8ko',
    icon: 'sgi sgi-21-8ko',
    choicePrefix: '8',
    badge: 'Bestseller',
    badgeColor: 'blue',
    description: 'SEE BETTER. Industry-leading materials for unrivalled performance.'
  },
  {
    tech: '8kop',
    icon: 'sgi sgi-21-8kop',
    choicePrefix: '8P',
    description: 'Our BEST lens yet. 8KO<sup>®</sup> plus anti-glare and contrast-enhancing polarisation.'
  }
]

export default defaultLensTechnologies

export function getLensTechnologies ($ld) {
  return $ld && $ld.isFlagActive('showLensTechIcons') ? experimentLensTechnologies : defaultLensTechnologies
}